"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typestyle_1 = require("typestyle");
var TabStyles_1 = require("../../styles/TabStyles");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TextEllipsis_1 = require("../../styles/TextEllipsis");
var BrowserDetection_1 = require("../../utils/BrowserDetection");
var Opacity = TabStyles_1.TabStyles.Opacity, Sizing = TabStyles_1.TabStyles.Sizing, Spacing = TabStyles_1.TabStyles.Spacing, Typography = TabStyles_1.TabStyles.Typography;
var _a = TabStyles_1.TabStyles.Colors, F2_5 = _a.F2_5, F3 = _a.F3;
exports.ListStyleName = typestyle_1.style(PreventUserSelect_1.PreventUserSelect, {
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    lineHeight: 'normal',
    overflowY: 'auto',
    padding: Spacing.DefaultSpace,
    '-webkit-overflow-scrolling': 'touch',
});
exports.FilteringListStyleName = typestyle_1.style({
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 'normal',
    $nest: {
        '&.reverse': {
            flexDirection: 'column-reverse',
        },
    },
});
exports.ListItemStyleName = typestyle_1.style(PreventUserSelect_1.PreventUserSelect, {
    alignItems: 'center',
    display: 'flex',
    minHeight: Sizing.ListRowHeight,
    paddingLeft: Spacing.DefaultSpace,
    paddingRight: Spacing.DefaultSpace,
    $nest: {
        '&::after': !BrowserDetection_1.isIE ? {} : {
            content: "\"\"",
            minHeight: 'inherit',
            fontSize: 0,
        },
        '&:hover': {
            backgroundColor: F2_5,
        },
        '&:focus': {
        // here to show the right precedence position for these styles if we use them later
        },
        '&:active, &[aria-selected="true"]': {
            backgroundColor: F3,
        },
        '&[aria-disabled="true"]': {
            backgroundColor: 'transparent',
            opacity: Opacity.Disabled,
        },
    },
});
exports.EllipsedStyleName = typestyle_1.style({ flexGrow: 1 }, TextEllipsis_1.TextEllipsis);
exports.SeparatorStyleName = typestyle_1.style({
    background: F3,
    height: 1,
    margin: '9.5px 0',
});
//# sourceMappingURL=ListStyles.js.map